<!--  DEALER HEADER  -->

<ui-dealer-header [location]="'engage_configure'"></ui-dealer-header>

<!--  END DEALER HEADER  -->

<!--  TERMS OF USE CONTENT  -->

<div class="written-content padded">
	<h3>TERMS OF USE</h3>
	<p>PLEASE READ THESE TERMS AND CONDITIONS CAREFULLY BEFORE USING THIS SITE</p>
	<h4>What's in these terms?</h4>
	<p>
		These terms tell you the rules for using our website
		<strong>{{ domain }}</strong>
		(our site), including to reserve a vehicle and/or book a test drive. You are responsible for ensuring that all
		persons who access our site through your internet connection are aware of, and comply with these terms of use
		and other applicable terms and conditions.
	</p>
	<p>
		We amend these terms from time to time. Every time you wish to use our site, please check these terms to ensure
		you understand the terms that apply at that time. These terms were most recently updated on 2nd August 2022.
	</p>
	<p>
		Our site is made available free of charge. We do not guarantee that it, or any content on it, will always be
		available or be uninterrupted. We may update and change our site from time to time to reflect changes to our
		products, our users' needs and our business priorities, and we may suspend or withdraw or restrict the
		availability of all or any part of it at any time for business or operational reasons.
	</p>
	<p>
		<strong>
			Please note that these terms do not apply to any contract for the purchase of the vehicle itself, nor to any
			contract for the provision of financial credit.
		</strong>
	</p>
	<p>Click on the links below to go straight to more information on each area:</p>

	<ul>
		<li>
			<a class="text-hl" (click)="goTo('who-we-are')">Who we are and how to contact us.</a>
		</li>
		<li>
			<a class="text-hl" (click)="goTo('site-usage')">By using our site you accept these terms.</a>
		</li>
		<li>
			<a class="text-hl" (click)="goTo('other-terms')">There are other terms that may apply to you.</a>
		</li>
		<li>
			<a class="text-hl" (click)="goTo('information-reliability')">Do not rely on information on our site.</a>
		</li>
		<li>
			<a class="text-hl" (click)="goTo('uk-users')">Our site is only for users in the UK.</a>
		</li>
		<li>
			<a class="text-hl" (click)="goTo('reserving-a-vehicle')">Reserving a vehicle or booking a test drive.</a>
		</li>
		<li>
			<a class="text-hl" (click)="goTo('cancellation')">
				Cancelling your reservation or booking and obtaining a refund.
			</a>
		</li>
		<ng-container *ngIf="dealer.enable_distance_selling_terms">
			<li>
				<a class="text-hl" (click)="goTo('part-exchanges')">Part exchanges.</a>
			</li>
			<li>
				<a class="text-hl" (click)="goTo('your-right-to-cancel')">Your right to cancel (distance sales).</a>
			</li>
		</ng-container>
		<li>
			<a class="text-hl" (click)="goTo('events-outside-our-control')">Events outside our control.</a>
		</li>
		<li>
			<a class="text-hl" (click)="goTo('site-material')">How you may use material on our site.</a>
		</li>
		<li>
			<a class="text-hl" (click)="goTo('external-links')">We are not responsible for websites we link to.</a>
		</li>
		<li>
			<a class="text-hl" (click)="goTo('loss-or-damage')">
				When we are responsible for loss or damage suffered by you.
			</a>
		</li>
		<li>
			<a class="text-hl" (click)="goTo('viruses')">
				We are not responsible for viruses and you must not introduce them.
			</a>
		</li>
		<li>
			<a class="text-hl" (click)="goTo('rules-for-linking-to-us')">Rules about linking to our site.</a>
		</li>
		<li>
			<a class="text-hl" (click)="goTo('general-provisions')">General provisions.</a>
		</li>
		<li>
			<a class="text-hl" (click)="goTo('disputes')">Which country's laws apply to any disputes?</a>
		</li>
		<li *ngIf="dealer.terms_and_conditions_url">
			<a class="text-hl" (click)="goTo('additional')">Additional Terms &amp; Conditions</a>
		</li>
	</ul>

	<h4 id="who-we-are">Who we are and how to contact us</h4>
	<p>
		<strong>{{ domain }}</strong>
		is a site operated by {{ dealer.friendly_name }}.
		<span *ngIf="dealer.friendly_name !== dealer.name">
			{{ dealer.friendly_name }} is a trading style of {{ dealer.name }}.
		</span>
		<span *ngIf="dealer.company_no">
			We are a limited company registered in England and Wales under company number {{ dealer.company_no }} and
			have our registered office at {{ dealer.address }}]. Our main trading address is {{ dealer.address }}.
		</span>
		<span *ngIf="dealer.vat_no">We are registered for VAT and our VAT number is {{ dealer.vat_no }}.</span>
	</p>
	<p>
		To contact us, please email
		<a [href]="'mailto:' + dealer.email" class="text-hl">{{ dealer.email }}</a>
		or telephone our customer service line on
		<strong>
			{{ dealer.telephone }}
		</strong>
		or write to us at
		<strong>{{ dealer.address }}</strong>
		.
	</p>

	<h4 id="site-usage">By using our site you accept these terms</h4>
	<p>
		By using our site to locate or reserve a vehicle or obtain finance quotes, you confirm that you accept these
		terms of use and that you agree to comply with them. They apply to the exclusion of any other terms that you
		seek to impose or incorporate, or which are implied by trade, custom, practice or course of dealing.
	</p>
	<p>If you do not agree to these terms, you must not use our site.</p>
	<p>
		These terms apply to any contract which may be concluded between us for the reservation and/or test drive of a
		vehicle you have found on this site. They are intended to represent the entire agreement between you and us in
		relation to its subject matter. If you are a business customer these terms constitute the entire agreement
		between us in relation to your purchase, and you acknowledge that you have not relied on any statement, promise,
		representation, assurance or warranty made or given by or on behalf of us which is not set out in these terms.
		If you are a consumer and believe you have relied on any statement, promise or representation or assurance or
		warranty that is not set out in these terms, please contact us to clarify the position.
	</p>
	<p>We recommend that you print a copy of these terms for future reference.</p>

	<h4 id="other-terms">There are other terms that may apply to you</h4>
	<p>These terms of use refer to the following additional terms, which also apply to your use of our site:</p>
	<ul>
		<li>
			Our terms and conditions of sale (available from {{ dealer.friendly_name }}), which set out the terms of any
			contract for the purchase of a vehicle.
		</li>
		<li>
			Our
			<a [routerLink]="['/configure/privacy-policy']" class="text-hl">Privacy Policy</a>
			, which sets out the terms on which we process any personal data we collect from you, or that you provide to
			us. By using our site, you consent to such processing and you warrant that all data provided by you is
			accurate.
		</li>
		<li>
			Our
			<a [routerLink]="['/configure/cookie-policy']" class="text-hl">Cookie Policy</a>
			, which gives you information about the cookies on our site.
		</li>
	</ul>

	<h4 id="information-reliability">Do not rely on information on this site</h4>
	<ul>
		<li>
			The content on our site is provided for general information only. It is not intended to amount to advice on
			which you should rely. You must obtain professional or specialist advice before taking, or refraining from,
			any action on the basis of the content on our site.
		</li>
		<li>
			Although we make reasonable efforts to update the information on our site, we make no representations,
			warranties or guarantees, whether express or implied, that the content on our site is accurate, complete or
			up to date.
		</li>
		<li>
			Any descriptions or illustrations on our site are for illustrative purposes only, and are published for the
			sole purpose of giving an approximate idea of the vehicles described in them. They will not form part of any
			contract or have any contractual force. We have made every effort to display the colours accurately, but we
			cannot guarantee that a device's display of the colours accurately reflects the colour of the vehicles.
		</li>
		<li>
			Any part exchange valuations obtained on this site are only estimates, based on the information you have
			submitted. The actual valuation will be agreed after we have appraised the part exchange vehicle.
		</li>
		<li>
			Any finance quotes obtained on this site are illustrative examples, based on the vehicle and the numbers you
			have submitted. Your application for finance will be processed by the finance company, not by us, and will
			take into account your personal credit rating so the actual finance quote may be different.
		</li>
		<li>
			We reserve the right to amend the specification of any vehicle described on this site if required to do so
			by any applicable statutory or regulatory requirement, to implement minor technical adjustments and
			improvements, or if the amendment will not materially affect its nature or quality.
		</li>
	</ul>

	<h4 id="uk-users">Our site is only for users in the UK</h4>
	<p>
		Our site is directed to people residing in the United Kingdom. We do not represent that content available on or
		through our site is appropriate for use or available in other locations. You may use this site to reserve a
		vehicle or test drive from an address outside the United Kingdom, but we do not deliver vehicles outside the
		United Kingdom, and any test drives must take place at the address in the United Kingdom which we specify.
		Finance quotes are not applicable to persons residing outside the United Kingdom.
	</p>

	<h4 id="reserving-a-vehicle">Reserving a vehicle or booking a test drive</h4>
	<p>
		Please follow the onscreen prompts to reserve your vehicle or book a test drive. You may do so only by using the
		method set out on the site. Each reservation or booking (Order) is an offer by you to pay our charges for
		reserving the vehicle until, or booking a test drive on, the agreed date, subject to these terms.
	</p>
	<p>
		It is your responsibility to ensure that the terms of the Order are complete and accurate. Our reservation and
		booking process allows you to check and amend any errors before submitting the Order to us. Please check it
		carefully before submission.
	</p>
	<p>
		You must pay the reservation or booking fee quoted on our site at the time you submit the Order, by PayPal or by
		using any of the following debit or credit cards: Visa, Mastercard or American Express. We will take your
		payment upon acceptance of the Order, and send you an electronic invoice. An administration fee may be levied
		for any failed or cancelled payments.
	</p>
	<p>
		You must co-operate with us in all matters relating to the Order, and provide us with such information as we may
		reasonably require in order to fulfil the Order, and ensure that such information is complete and accurate in
		all material respects, and you hold a full UK driving licence on the date booked for the test drive.
	</p>
	<p>
		After you submit the Order, you will receive an email from us acknowledging that we have received it, but please
		note that this does not mean that it has been accepted. Our acceptance of the Order will take place when we send
		an email to you to accept it (
		<strong>Confirmation</strong>
		), at which point and on which date a contract between you and us will come into existence. The contract will
		relate only to the reservation or booking confirmed in the Confirmation.
	</p>
	<p>
		<strong>
			If we are unable to reserve the vehicle or offer you a test drive on the specified date, we will inform you
			of this by email and we will not process your order.
		</strong>
		This might be because the vehicle has already been sold, because of unexpected limits on our resources which we
		could not reasonably plan for, because a credit reference we have obtained for you does not meet our minimum
		requirements, because we have identified an error in the price or description of the vehicle or because we are
		unable to meet an agreed deadline.
		<strong>If you have already paid for the Order, we will refund you the full amount paid.</strong>
	</p>

	<p>
		If, despite our best efforts, the fee quoted on our site for the Order on the date you place the Order is
		incorrect and the correct price is less than the price stated on our site, we will charge the lower amount. If
		the correct price for the Services is higher than the price stated on our site, we will contact you as soon as
		possible to inform you of this error and we will give you the option of confirming the Order at the correct
		price or cancelling the Order. We will not process the Order until we have your instructions. If we are unable
		to contact you using the contact details you provided during the order process, we will treat the order as
		cancelled and notify you in writing. However, if we mistakenly accept and process your order where a pricing
		error is obvious and unmistakeable and could reasonably have been recognised by you as a mispricing, we may
		cancel the Order and refund you any sums you have paid.
	</p>
	<p>
		We will use all reasonable endeavours to meet any dates specified in the Confirmation, but any such dates are
		not guaranteed and, whilst we will use all reasonable endeavours to notify you in advance if we are unable to
		ensure a vehicle is available for a test drive on the specified date and to agree a mutually convenient
		alternative date, you will have no rights or remedies against us if we fail to ensure a vehicle is so available.
	</p>
	<p>
		If you fail to pay the amount due when placing the Order or to provide us with any required information, or if
		we are not satisfied you hold a full UK driving licence and are legally fit to drive the vehicle on the date
		booked for the test drive, we will be entitled to cancel the Order and require you to rearrange an alternative
		date for the test drive. In these circumstances, you will not be entitled to a refund of any reservation or
		booking fee paid, and may be required to reimburse us on written demand for any costs or losses we sustain or
		incur arising directly or indirectly from failure.
	</p>
	<p>
		If you wish to make a change to a date you have booked for a test drive, please contact us as soon as possible
		to book an alternative date. We may not be able to guarantee that the vehicle will still be available.
	</p>
	<p>
		The reservation/booking fee is only a good faith deposit, and placing an Order does not guarantee we will not
		sell the vehicle to another customer before the reservation period has expired or before the date booked for
		your test drive. However, if we do so, we will, of course, refund the reservation/booking fee in full.
	</p>
	<p>
		If you subsequently agree to purchase the vehicle, we may agree to credit the reservation/booking fee against
		the purchase price.
	</p>

	<h4 id="cancellation">Cancelling your reservation or booking and obtaining a refund</h4>
	<p>
		If you are a consumer and the reservation or booking date is at least 14 days after you received the
		Confirmation, you have a legal right under the Consumer Contracts Regulations 2013 to change your mind within 14
		days of receiving the Confirmation and receive a refund.
		<strong>
			However, if you cancel a reservation after the date of the Confirmation, we will only refund that part of
			the reservation fee which the period between the date we receive your cancellation and the end of the
			reservation period bears to the total period between the date of the Confirmation and the end of the
			reservation period. Due to the work which will be require to prepare the vehicle for a test drive, there is
			no right to any refund if you cancel a test drive booking less than 14 days before the booking date. There
			is, of course, no right to cancel and receive any refund after you have inspected and/or test driven the
			vehicle, even if the 14-day period is still running.
		</strong>
	</p>
	<p>
		To cancel the Order, please complete the
		<a href="/assets/downloads/cancellation_form.pdf" target="_blank" class="text-hl">Cancellation Form</a>
		and send to {{ dealer.address }}. We will email you to confirm we have received your cancellation.
	</p>
	<p>
		Alternatively, you may telephone, email or write to us as described under “Who we are and how to contact us”
		above. If you are emailing us or writing to us, please include details of the Order to help us to identify it
		and your name and address. If you contact us to cancel by email or by post, then your cancellation is effective
		from the date you send the email or post the letter to us. For example, you will have given us notice in time as
		long as you get your letter into the last post on the last day of the cancellation period or email us before
		midnight on that day.
	</p>
	<p>
		If you cancel the Order and are entitled to a refund of all or any part of the reservation fee you have paid, we
		will make the refund by the same method as you used for payment, as soon as possible and in any event within 14
		days of your telling us you have changed your mind.
	</p>

	<ng-container *ngIf="dealer.enable_distance_selling_terms">
		<h4 id="part-exchanges">Part exchanges</h4>
		<p>
			When a Customer chooses to use a Part Exchange Vehicle in partial payment of the Purchase Price, they must
			provide all required details of the Part Exchange Vehicle to {{ dealer.name }} as part of their Order. We
			may require additional information about the Part Exchange Vehicle at any time prior to the Delivery or
			Collection of the Vehicle.
		</p>
		<p>
			The valuation for the Part Exchange Vehicle will be given to you when you place your Order. You must provide
			us with authentic, accurate, and up-to-date information about the Part Exchange Vehicle. We will inspect the
			Part Exchange Vehicle on Delivery or Collection to confirm all the information you provided us while placing
			your Order was true and accurate. We will also need to confirm that the Part Exchange Vehicle is roadworthy
			and has not sustained any undisclosed damage.
		</p>
		<p>
			If we accept Your Part Exchange Vehicle request, You are required to make the Part Exchange Vehicle
			available for inspection upon Delivery or Collection of Your Vehicle. We are not in any way obligated to
			provide You a part exchange option when selling the Vehicle to You and our decision to inspect and value a
			Part Exchange Vehicle, including the valuation we give, is solely at our discretion.
		</p>
		<p>
			You are required to notify us of any outstanding finance that Your Part Exchange Vehicle has when providing
			us details of Your Part Exchange Vehicle. The information you provide us about your finance provider and
			settlement must be accurate.
		</p>
		<p>
			In order to use Your Part Exchange Vehicle with outstanding finance to contribute towards the purchase of
			Your Vehicle:
		</p>
		<ul>
			<li>
				You must possess a settlement confirmation letter from Your finance provider that is valid for no less
				than 7 days after the date of Delivery or Collection of Your Vehicle; and
			</li>
			<li>
				In cases where the outstanding finance amount exceeds our valuation of Your Part Exchange Vehicle, You
				are required to pay us the difference (the "Negative Equity Amount"), or if You are buying through a
				finance provider, Your deposit must be greater than the Negative Equity Amount.
			</li>
			<li>
				We have limited existing relationships with vehicle finance providers. So, if Your Part Exchange Vehicle
				has outstanding finance, we may require Your assistance to contact your finance provider to clear any
				outstanding finance on Your Part Exchange Vehicle, both before and after you have handed over Your Part
				Exchange Vehicle to us. You hereby agree to provide any information and assistance that we reasonably
				request to get this done. In case Your finance provider declines or otherwise fails to clear the
				outstanding finance on Your Part Exchange Vehicle, you may be required to make a further cash payment to
				clear the outstanding finance amount or you will have to return Your Vehicle to us. We will contact you
				if such cases arise.
			</li>
		</ul>
		<p>
			We reserve the right to reject a Part Exchange Vehicle at any time, whether before or at Delivery or
			Collection, if:
		</p>

		<ul>
			<li>
				We discover You are not legally capable of entering into a binding contract to sell the Part Exchange
				Vehicle;
			</li>
			<li>
				We discover You are not the sole owner of the Part Exchange Vehicle (including, if relevant, the
				electric vehicle battery);
			</li>
			<li>
				We discover a third-party has any claim to the Part Exchange Vehicle or there is outstanding finance on
				the Part Exchange Vehicle;
			</li>
			<li>
				You are not listed as the registered keeper of the Part Exchange Vehicle on the V5C registration
				document;
			</li>
			<li>You have owned the Part Exchange Vehicle for less than 90 days;</li>
			<li>
				We discover that any part of the information you provided us about the Part Exchange Vehicle is
				falsified and inaccurate;
			</li>
			<li>
				There is undisclosed damage on the Part Exchange Vehicle that you failed to reveal during Your order;
			</li>
			<li>
				There is a material discrepancy in the information and documents supplied by you in respect of the Part
				Exchange Vehicle or a material document is missing, inaccurate, or incomplete (for example, the V5C
				registration document is missing or incomplete);
			</li>
			<li>
				The Part Exchange Vehicle has any fault which affects the value of the Part Exchange Vehicle or makes it
				not roadworthy;
			</li>
			<li>
				The Part Exchange Vehicle is not registered in the United Kingdom or was not originally registered in
				the United Kingdom;
			</li>
			<li>
				We discover there is a finance marker on the Part Exchange Vehicle or any other issue is identified by
				an HPI check;
			</li>
			<li>There is no valid MOT for the Part Exchange Vehicle;</li>
			<li>
				The Part Exchange Vehicle has been involved in a major accident or has been subject to a total loss
				claim;
			</li>
			<li>The Part Exchange Vehicle does not have its legal registration and chassis number;</li>
			<li>
				The Part Exchange Vehicle is imported (that is, it is not a right-hand drive vehicle with UK
				registration plates or was not first registered in the UK);
			</li>
			<li>
				The Part Exchange Vehicle has been modified from its original design for appearance or performance
				purposes;
			</li>
			<li>
				The mileage of the Part Exchange Vehicle exceeds 200 miles above the mileage stated in the Order; or
			</li>
			<li>
				The Part Exchange Vehicle has been used for commercial purposes, private hire, rental, driving tuition,
				as an emergency services vehicle, or by a local authority.
			</li>
		</ul>

		<p>
			If you are selling a Part Exchange Vehicle to us, we will need to inspect the Part Exchange Vehicle at
			Delivery or on Collection (as applicable). We reserve the right to reject the Part Exchange Vehicle for any
			reason, including if the Part Exchange Vehicle is faulty, damaged, or is not roadworthy (for example, if it
			doesn't start). If we reject the Part Exchange Vehicle, then the Order will be subsequently cancelled, and
			Delivery or Collection will not take place. Any payments you made to us for the Vehicle will be refunded to
			you within 14 days. We will refund you through the same means of payment you used to execute the payment,
			you will not be charged any fee in relation to the repayment.
		</p>
		<p>If we accept and collect the Part Exchange Vehicle at Delivery or Collection, you must give us:</p>

		<ul>
			<li>Every copy of the Part Exchange Vehicle's keys;</li>
			<li>
				The Most recent V5C registration document of The Part Exchange Vehicle's (including appropriate proof of
				purchase upon our request);
			</li>
			<li>The service history of The Part Exchange Vehicle (if any);</li>
			<li>The MOT certificate of The Part Exchange Vehicle (if any);</li>
			<li>The user manual for The Part Exchange Vehicle (if any); and</li>
			<li>
				Any accessories there may be such as a locking wheel nut, radio fascia, remote controls, SD card, and/or
				charging cables (if you have a plug-in vehicle).
			</li>
		</ul>

		<p>
			It is Your responsibility to remove all personal belongings in the Part Exchange Vehicle before we collect
			it. We will not be held liable for any missing personal belonging after the collection of the Part Exchange
			Vehicle.
		</p>
		<p>
			You are responsible for removal, deletion or redaction of your personal information contained in the Part
			Exchange Vehicle prior to handover of the Part Exchange Vehicle, including as follows:
		</p>

		<ul>
			<li>
				If the Part Exchange Vehicle has a preinstalled satnav, phone interface, or any other device capable of
				storing data, it is Your duty to have all personal data removed from these devices prior to handing the
				Part Exchange Vehicle over to us. Such data includes contacts (names and numbers), previous or favourite
				destinations in your trip history and default "home" address; and
			</li>
			<li>
				You will ensure that your name and address are removed or redacted from any service or maintenance
				records that you hand over with the Part Exchange Vehicle.
			</li>
		</ul>

		<p>
			Any document related to V5C registration (that includes your name and address and is an official DVLA
			document) shall remain with the Part Exchange Vehicle until a sale is made and re-registered by a new
			registered keeper or scrapped. Kindly note that before being re-registered by a new keeper, the Part
			Exchange Vehicle may be sold to one or more motor traders who will not be obliged to register as the new
			keeper of the Part Exchange Vehicle and remove your name and address from the V5C registration document. We
			do not accept any liability in respect of your personal information contained on the V5C registration
			document.
		</p>
		<p>
			If You fail to comply with these hand-over requirements, you hereby agree that we reserve the right to
			withdraw any offer to buy the Part Exchange Vehicle without prior notice and/or to indicate a new valuation
			at which we are ready to purchase the Part Exchange Vehicle and/or outrightly cancel the Order in accordance
			with section 9 of these Terms. If we take the Part Exchange Vehicle at Delivery or Collection and we later
			find out that the Part Exchange Vehicle does not meet the requirements set out in this Section 9 we may take
			legal action against you to recover the reduction in the value of the Part Exchange Vehicle due to the Part
			Exchange Vehicle not conforming with the requirements in this section 9 (Recovery Claim). You may also have
			to cover on-demand all reasonable costs and expenses we incurred while pursuing a Recovery Claim.
		</p>
		<p>
			In the event that a vehicle is sold to {{ dealer.name }}, whether outright or in part exchange, the Customer
			must assist {{ dealer.name }} in transferring the cherished number plate via the Driver and Vehicle
			Licensing Agency (DVLA). Failure to claim the cherished number plate after title of goods has been
			transferred on to {{ dealer.name }} will result in the number becoming the property of {{ dealer.name }} and
			we will accept no liability for loss / damages.
		</p>

		<h4 id="your-right-to-cancel">Your right to cancel (distance sales)</h4>
		<p>
			As a distance sales consumer you have a statutory right to cancel your contract with us up to 14 Calendar
			Days after the vehicle comes into your physical possession (i.e., you or another person identified by you
			taking delivery of the vehicle). You may cancel your contract and return the vehicle to us for any reason
			under this right. You are liable for the cost of returning the vehicle to us or you can agree to indemnify
			us for the cost of collecting the vehicle.
		</p>
		<p>
			If you wish to exercise your right to cancel you must inform us of your decision. You may do so in writing
			in any way that is convenient to you, please ensure you use the address as stated on the front of our
			invoice or via email. Please ensure that you inform us of your decision to cancel before the period in
			subClause 18.1 expires. Should you wish for us to provide a template to you for this we are happy to do so.
		</p>
		<p>
			Please note that your statutory right to cancel may be lost If the vehicle has been damaged or modified in
			any way or is not in the same condition as when it was delivered to you.
		</p>
		<p>
			You must return the vehicle to us no more than 7 Calendar Days after the day on which you have informed us
			that you wish to cancel.
		</p>
		<p>
			You may return the vehicle to us in person or with the assistance of a delivery company during our normal
			business hours of 9am-5pm Monday to Friday.
		</p>
		<p>Refunds will be issued to you within 14 Calendar Days of the following:</p>
		<ul>
			<li>The day on which we receive the Goods back; or</li>
			<li>The day on which you inform us (supplying evidence) that you have sent the Goods back;</li>
			<li>
				If we are collecting the Vehicle, the day on which you inform us that you wish you cancel the contract
			</li>
			<li>
				If we have not yet provided an Order Confirmation or have not yet dispatched the vehicle, the day on
				which you inform us that you wish to cancel the Contract.
			</li>
		</ul>
		<p>Refunds may be subject to deductions in the following circumstances:</p>
		<ul>
			<li>
				Refunds may subject to deductions for any diminished value in the vehicle resulting from your excessive
				handling of them and an excess mileage charge of £1/mile will be levied for any mileage over 30 miles in
				the 14 days.
			</li>
		</ul>
		<p>Refunds will be made using the same payment method you used when ordering the vehicle.</p>
		<p>
			Once you have confirmed to us that the contract is cancelled you will not use the vehicle but will remain
			liable to ensure that the vehicle is taxed and insured until it is collected.
		</p>
		<p>
			<strong>
				This cancellation clause does not affect any other of your statutory rights under the Consumer Rights
				Act 2015 or the Sale of Goods Act 1979.
			</strong>
		</p>
	</ng-container>

	<h4 id="events-outside-our-control">Events outside our control</h4>
	<p>
		We will not be liable or responsible for any failure to perform, or delay in performance of, any of our
		obligations under the Contract that is caused by any act or event beyond our reasonable control (
		<strong>Event Outside Our Control</strong>
		).
	</p>
	<p>
		If an Event Outside Our Control takes place that affects the performance of our obligations under the Contract,
		we will contact you as soon as possible to let you know and we will take steps to minimise the effect of the
		delay. We will arrange a new date for the test drive after the Event Outside Our Control is over. Provided we do
		this we will not be liable for delays caused by the event, but if the Event Outside Our Control has continued,
		or seems likely to continue, for more than 30 days, you may contact us to cancel the Order and receive a refund
		of any reservation or booking fee you have paid.
	</p>

	<h4 id="site-material">How you may use material on our site</h4>
	<p>
		We are the owner or the licensee of all intellectual property rights in our site, and in the material published
		on it. Those works are protected by copyright laws and treaties around the world. All such rights are reserved.
	</p>
	<p>
		You may print off one copy, and may download extracts, of any page(s) from our site for your personal use and
		you may draw the attention of others within your organisation to content posted on our site.
	</p>
	<p>
		You must not modify the paper or digital copies of any materials you have printed off or downloaded in any way,
		and you must not use any illustrations, photographs, video or audio sequences or any graphics separately from
		any accompanying text.
	</p>
	<p>
		Our status (and that of any identified contributors) as the authors of content on our site must always be
		acknowledged.
	</p>
	<p>
		You must not use any part of the content on our site for commercial purposes without obtaining a licence to do
		so from us or our licensors.
	</p>
	<p>
		You print off, copy or download any part of our site in breach of these terms of use, your right to use our site
		will cease immediately and you must, at our option, return or destroy any copies of the materials you have made.
	</p>

	<h4 id="external-links">We are not responsible for websites we link to</h4>
	<p>
		Where our site contains links to other sites and resources provided by third parties, these links are provided
		for your information only. Such links should not be interpreted as approval by us of those linked websites or
		information you may obtain from them.
	</p>
	<p>We have no control over the contents of those sites or resources.</p>

	<h4 id="loss-or-damage">Our responsibility for loss or damage suffered by you</h4>
	<p>
		<strong>Whether you are a consumer or a business user:</strong>
	</p>
	<ul>
		<li>
			We do not exclude or limit in any way our liability to you where it would be unlawful to do so. This
			includes liability for death or personal injury caused by our negligence or the negligence of our employees,
			agents or subcontractors and for fraud or fraudulent misrepresentation.
		</li>
		<li>
			Different limitations and exclusions of liability will apply to liability arising as a result of the supply
			of any products to you, which will be set out in our Terms and conditions.
		</li>
		<li>
			Nothing in these terms limits or affects the exclusions and limitations set out in our Terms and Conditions
			of Sale (available from {{ dealer.name }}).
		</li>
		<li>This section will survive the termination of any contract between us.</li>
	</ul>

	<p>
		<strong>Only if you are a business user:</strong>
	</p>
	<ul>
		<li>
			We exclude all implied conditions, warranties, representations or other terms that may apply to our site or
			any content on it. Any representation, condition or warranty which might be implied or incorporated into
			these terms by statute, including without limitation the terms which might be implied in any contract for
			the sale of a vehicle by sections 3 to 5 of the Supply of Goods and Services Act 1982, by common law or
			otherwise are, to the fullest extent permitted by law, excluded from any contract between us.
		</li>
		<li>
			We will not be liable to you for any loss or damage, whether in contract, tort (including negligence),
			breach of statutory duty, or otherwise, even if foreseeable, arising under or in connection with use of, or
			inability to use, our site or use of or reliance on any content displayed on our site.
		</li>
		<li>
			In particular, we will not be liable for loss of profits, sales, business, or revenue; business
			interruption; loss of anticipated savings; loss of business opportunity, goodwill or reputation; or any
			indirect or consequential loss or damage.
		</li>
		<li>
			Subject to the previous paragraphs of this section, our total liability to you arising under or in
			connection with any contract between us, whether in contract, tort (including negligence), breach of
			statutory duty, or otherwise, will be limited to the total amount payable by you under the contract.
		</li>
	</ul>

	<h4 id="viruses">We are not responsible for viruses and you must not introduce them</h4>
	<p>We do not guarantee that our site will be secure or free from bugs or viruses.</p>
	<p>
		You are responsible for configuring your information technology, computer programmes and platform to access our
		site. You should use your own virus protection software.
	</p>
	<p>
		You must not misuse our site by knowingly introducing viruses, trojans, worms, logic bombs or other material
		that is malicious or technologically harmful. You must not attempt to gain unauthorised access to our site, the
		server on which our site is stored or any server, computer or database connected to our site. You must not
		attack our site via a denial-of-service attack or a distributed denial-of service attack. By breaching this
		provision, you would commit a criminal offence under the Computer Misuse Act 1990. We will report any such
		breach to the relevant law enforcement authorities and we will co-operate with those authorities by disclosing
		your identity to them. In the event of such a breach, your right to use our site will cease immediately.
	</p>

	<h4 id="rules-for-linking-to-us">Rules about linking to our site</h4>
	<p>
		You may link to our home page, provided you do so in a way that is fair and legal and does not damage our
		reputation or take advantage of it.
	</p>
	<p>
		You must not establish a link in such a way as to suggest any form of association, approval or endorsement on
		our part where none exists.
	</p>
	<p>You must not establish a link to our site in any website that is not owned by you.</p>
	<p>
		Our site must not be framed on any other site, nor may you create a link to any part of our site other than the
		home page.
	</p>
	<p>We reserve the right to withdraw linking permission without notice.</p>
	<p>
		If you wish to link to or make any use of content on our site other than that set out above, please contact
		<a [href]="'mailto:' + dealer.email" class="text-hl">{{ dealer.email }}</a>
		.
	</p>

	<h4 id="general-provisions">General provisions</h4>
	<p>
		<strong>Assignment and transfer:</strong>
		We may assign or transfer our rights and obligations under the Contract to another entity but will always notify
		you in writing or by posting on this webpage if this happens. You may only assign or transfer your rights or
		your obligations under the Contract to another person if we agree in writing.
	</p>
	<p>
		<strong>Waiver:</strong>
		If we do not insist that you perform any of your obligations under the Contract, or if we do not enforce our
		rights against you, or if we delay in doing so, that will not mean that we have waived our rights against you or
		that you do not have to comply with those obligations. If we do waive any rights, we will only do so in writing,
		and that will not mean that we will automatically waive any right related to any later default by you.
	</p>
	<p>
		<strong>Severance:</strong>
		Each paragraph of these Terms operates separately. If any court or relevant authority decides that any of them
		is unlawful or unenforceable, the remaining paragraphs will remain in full force and effect.
	</p>
	<p>
		<strong>Third party rights:</strong>
		The Contract is between you and us. No other person has any rights to enforce any of its terms.
	</p>
	<p>
		<strong>Complaints:</strong>
		If a problem arises or you are dissatisfied with the Services, we have a comprehensive complaints policy
		(available from {{ dealer.friendly_name }}).
	</p>
	<p>
		<strong>Alternative dispute resolution:</strong>
		Alternative dispute resolution is a process where an independent body considers the facts of a dispute and seeks
		to resolve it, without you having to go to court. If you are a consumer and are not happy with how we have
		handled any complaint, you may want to contact the alternative dispute resolution provider we use. You can
		submit a complaint to Trading Standards. You can find your local branch via their
		<a href="https://www.tradingstandards.uk/consumers/support-advice" target="_blank" class="text-hl">website</a>
		. In addition, please note that disputes may be submitted for online resolution to the
		<a href="http://ec.europa.eu/odr" target="_blank" class="text-hl">
			European Commission Online Dispute Resolution platform
		</a>
		.
	</p>

	<h4 id="disputes">Which country's laws apply to any disputes?</h4>
	<p>
		If you are a consumer, please note that these terms of use, their subject matter and their formation, are
		governed by English law. You and we both agree that the courts of England and Wales will have exclusive
		jurisdiction except that, if you are a resident of Northern Ireland you may also bring proceedings in Northern
		Ireland and, if you are resident of Scotland, you may also bring proceedings in Scotland.
	</p>
	<p>
		If you are a business, these terms of use, their subject matter and their formation (and any non-contractual
		disputes or claims) are governed by English law. We both agree to the exclusive jurisdiction of the courts of
		England and Wales.
	</p>

	<ng-template [ngIf]="dealer.terms_and_conditions_url">
		<h4 id="additional">Additional Terms &amp; Conditions</h4>
		<p>
			By agreeing to these Terms of Use you also agree to the
			<a [href]="dealer.terms_and_conditions_url" target="_blank" class="text-hl">
				Terms &amp; Conditions found here
			</a>
			.
		</p>
	</ng-template>
</div>

<!--  END TERMS OF USE CONTENT  -->

<!--  FOOTER LINKS  -->

<cng-legal-footer-links></cng-legal-footer-links>

<!--  END FOOTER LINKS  -->

<!--  SCROLL FADES  -->

<div class="scroll-fade top"></div>

<!--  END SCROLL FADES  -->
